class SwipeHandler {
	getSwipeDirection({ touchstartX, touchstartY, touchendX, touchendY }) {
		const delx = touchendX - touchstartX;
		const dely = touchendY - touchstartY;
		if (Math.abs(delx) > Math.abs(dely)) {
			return delx > 0 ? "right" : "left";
		}
		if (Math.abs(delx) < Math.abs(dely)) {
			return dely > 0 ? "down" : "up";
		}
		return "tap";
	}
}

class ToastsFactory {
	constructor() {
		this.swipeHandler = new SwipeHandler();
		this.createToastsContainer();
	}
	createToastsContainer() {
		const toastsContainer = document.createElement("div");
		toastsContainer.classList.add("cagliari--toasts-container");
		this.toastsContainer = toastsContainer;
		document.body.appendChild(toastsContainer);
	}
	createToast({ type, icon, message, duration, redirect = false, callback = false }) {
		const toast = this.createToastContainer(type);
		this.addToastElement(toast, "t-message", message);
		this.addCloseButton(toast, redirect, callback);
		const progressBar = this.getProgressBar(duration);
		progressBar && toast.appendChild(progressBar);
		this.observeSwipe(toast, "right");
		this.toastsContainer.appendChild(toast);
		if (!progressBar)
				return;
		
		if(redirect){
			progressBar.onanimationend = () => {
				this.removeToast(toast)
				window.location.href = redirect
			};
		}else{
			if(callback){
				progressBar.onanimationend = () => {
					this.removeToast(toast)
					callback()
				};
			}else{
				progressBar.onanimationend = () => this.removeToast(toast);
			}
		}
		
	}
	createToastContainer(type){
		const toast = document.createElement("div");
		toast.classList.add("toast", type, "active");
		return toast;
	}
	addToastElement(toast, className, content){
		const element = document.createElement("div");
		element.classList.add(className);
		Object.entries(content).forEach(([tag, el]) => {
			const elTag = document.createElement(tag);
			elTag.innerHTML = el;
			element.appendChild(elTag);
		})
		//element.innerHTML = content;
		toast.appendChild(element);
		return element;
	}
	addCloseButton(toast, redirect, callback) {
		const closeButton = this.addToastElement(toast, "t-close", '');
		if(redirect){
			closeButton.onclick = () => {
				window.location.href = redirect
				this.removeToast(toast)
			};
		}else{
			if(callback){
				closeButton.onclick = () => {
					this.removeToast(toast)
					callback()
				};
			}else{
				closeButton.onclick = () => this.removeToast(toast);
			}
		}
		
	}
	getProgressBar(duration){
		// duration is infinite => no progress bar
		if (duration === 0)
				return;
		const progressBar = document.createElement("div");
		progressBar.classList.add("t-progress-bar");
		duration &&
				progressBar.style.setProperty("--toast-duration", `${duration}ms`);
		return progressBar;
	}
	removeToast(toast){
		toast.classList.remove("active");
		toast.onanimationend = (evt) => {
			evt.target === toast && toast.remove();
		};
		const loggedInEvent = new CustomEvent("ToastClosed", { bubbles: true });
   	window.dispatchEvent(loggedInEvent);
	}
	observeSwipe(toast, direction){
		let touchstartX = 0, touchstartY = 0, touchendX = 0, touchendY = 0;
		toast.addEventListener("touchstart", (event) => {
			// needed to avoid weird behavior on swipe
			window.document.body.style.overflow = "hidden";
			touchstartX = event.changedTouches[0].screenX;
			touchstartY = event.changedTouches[0].screenY;
		}, { passive: true });
		toast.addEventListener("touchend", (event) => {
			window.document.body.style.overflow = "unset";
			touchendX = event.changedTouches[0].screenX;
			touchendY = event.changedTouches[0].screenY;
			const swipeConfig = {
					touchstartX,
					touchstartY,
					touchendX,
					touchendY
			};
			this.swipeHandler.getSwipeDirection(swipeConfig) === direction &&
				this.removeToast(toast);
		}, { passive: true });
	}
}

export { ToastsFactory }